import React from "react";
import "./footerCardEvent.sass";

export default function FooterCardEvent({urlmomioEvento, classPatrocinador}) {
  return (
    <div className="footer-card-evento">
      <a href={urlmomioEvento} className={"buttonJuegaAqui " + classPatrocinador} target="_blank" rel="noreferrer">Juega Aquí</a>
    </div>
  );
}
